import React from 'react'
import { Typography } from '@material-ui/core'

const UserMenu = ({ dataUser }) => {

    return (
    <Typography variant="body2" >
    {/* <Link
        className={classes.menuLink}
        component={'a'}
        href={`https://atendimento.manole.com.br/aprimora/?e=${btoa(((dataUser || {}).usuario || {}).email)}`}
        rel="noopener"
        target="_blank"
        ><MenuItem >Suporte </MenuItem></Link>
        <Link href="javascript:void(0)" className={classes.menuLink}><MenuItem onClick={handleLogout}>Sair</MenuItem></Link>
        {/* <Link href="profile" className={classes.menuLink}><MenuItem  onClick={() => console.log('clicked!')}>Perfil</MenuItem></Link>
        <Link href="myAccount" className={classes.menuLink}><MenuItem onClick={() => console.log('clicked!')}>Minha conta</MenuItem></Link>
        <Link href="suport" className={classes.menuLink}><MenuItem onClick={() => console.log('clicked!')}>Suporte</MenuItem></Link> */}
    </Typography>)
}

export default UserMenu